<template>
  <div class="info-region-container">
    <div class="all-content-container" v-allow="'0603'" style="margin: 0 auto; width: 100%">
      <div class="container1">
        <div class="titlemaun" style="">
          <h4>离线模板配置</h4>
          <el-button type="primary" class="adduser" @click="handleAdd()">添加</el-button>
        </div>
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="模板名称：" prop="name">
            <el-input v-model="searchForm.name" placeholder="请输入模板名称" maxlength="50" show-word-limit clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="button" @click="searchKey()">查询</el-button>
            <el-button type="button" ass="button" @click="reset()">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="info-content-container">
        <div class="table_content1" style="margin-top: 10px">
          <el-table :data="tableData" align="center" class="data-table" style="width: 100%"
            :header-cell-style="{ background: '#F4F5F7' }">
            <el-table-column align="center" label="序号" width="95">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column label="模板名称" align="center">
              <template slot-scope="scope">
                <p>{{ scope.row.name }}</p>
              </template>
            </el-table-column>
            <el-table-column label="修改人" align="center">
              <template slot-scope="scope">
                <p>{{ scope.row.username }}</p>
              </template>
            </el-table-column>
            <el-table-column label="修改日期" align="center">
              <template slot-scope="scope">
                <p>{{ scope.row.updateTime }}</p>
              </template>
            </el-table-column>
            <el-table-column fixed="right" align="center" label="操作">
              <template slot-scope="scope">
                <el-button @click="handleUpdate(scope.row)" type="text">编辑</el-button>
                <el-button style="margin-left: -1rem;" type="text" @click="handleDel(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-container">
          <div class="page"></div>
          <div class="pagination-content-container">
            <el-pagination background layout="prev, pager, next,jumper" class="pageTap"
              @current-change="handleCurrentChange" :current-page="searchForm.pageNum" :page-size="searchForm.pageSize"
              :total="total"></el-pagination>
          </div>
        </div>
        <el-dialog :title="title" :visible.sync="dialogVisible" width="1300px" :before-close="handleClose">
          <el-form ref="ruleForm" :rules="rules" :model="ruleForm" label-width="120px" class="demo-ruleForm">
            <el-row>
              <el-col :span="24">
                <el-form-item label="模板名称：" prop="name">
                  <el-input placeholder="请输入模板名称" v-model="ruleForm.name" maxlength="50" show-word-limit
                    clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-for="(item, index) in ruleForm.offlineDetails" :key="index">
              <el-col :span="item.type == 0 ? 8 : 6">
                <el-form-item label="提醒类型：">
                  <el-select v-model="item.type" placeholder="请选择提醒类型" clearable style="width: 100%">
                    <el-option label="当日" value="0"></el-option>
                    <el-option label="次日" value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8" v-if="item.type == 0">
                <el-form-item label="间隔分钟：">
                  <el-input-number placeholder="请输入间隔分钟" v-model="item.intervalTime" :precision="0" :step="1" :min="1"
                    :max="1440" size="small" style="width: 100%"></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="item.type == 1">
                <el-form-item label="间隔天数：">
                  <el-input-number placeholder="请输入间隔天数" v-model="item.intervalDay" :precision="0" :step="1" :min="1"
                    :max="14" size="small" style="width: 100%"></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="item.type == 1">
                <el-form-item label="提醒时间：">
                  <el-time-select v-model="item.remindTime" :picker-options="{
                    start: '00:00',
                    step: '00:05',
                    end: '23:59',
                  }" placeholder="请选择提醒时间" style="width: 100%">
                  </el-time-select>
                </el-form-item>
              </el-col>
              <el-col :span="item.type == 0 ? 8 : 6">
                <el-form-item label="推送模式：">
                  <el-select v-model="item.pushModeArr" multiple collapse-tags placeholder="请选择推送模式" style="width: 100%">
                    <el-option v-for="item in pushModeoptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <span style="
                  display: block;
                  float: right;
                  margin-right: -45px;
                  margin-top: 10px;
                  color: red;
                  cursor: pointer;
                " @click="handleDelDetail(index)">删除</span>
            </el-row>
            <el-form-item>
              <a class="td-opption" @click="handleAddDetail()">+添加模板明细</a>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="handleClose()">取消</el-button>
            <el-button type="primary" @click="handleSave()">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import store from "@/store/index";

export default {
  data() {
    return {
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        name: "",
      },
      ruleForm: {
        // 添加、编辑弹窗表单
        id: undefined,
        name: "",
        offlineDetails: [
          {
            id: undefined,
            type: "",
            intervalTime: "",
            intervalDay: "",
            remindTime: "",
            pushMode: "",
            pushModeArr: [],
          },
        ],
      },
      rules: {
        // 添加、编辑弹窗表单规则
        name: [
          {
            required: true,
            message: "请输入模板名称",
            trigger: "blur",
          },
        ],
      },
      total: 0, // 总数
      tableData: [],
      dialogVisible: false,
      title: "添加离线模板", // 添加、编辑弹窗标题
      pushModeoptions: [
        {
          value: "0",
          label: "邮箱发送",
        },
        {
          value: "1",
          label: "短信发送",
        },
        {
          value: "2",
          label: "APP推送",
        },
        {
          value: "3",
          label: "小程序推送",
        },
        {
          value: "4",
          label: "语音拨号提醒",
        },
      ],
    };
  },
  created() {
    // 查询
    this.searchKey();
  },
  methods: {
    // 查询
    searchKey() {
      this.searchForm.pageNum = 1;
      this.getModelOfflineSettingsList();
    },
    // 分页查询
    handleCurrentChange: function (currentPage) {
      this.searchForm.pageNum = currentPage;
      this.getModelOfflineSettingsList();
    },
    // 重置
    reset() {
      this.searchForm = {
        pageNum: 1,
        pageSize: 10,
        name: "",
      };
      this.searchKey();
    },
    // 获取离线模板列表
    getModelOfflineSettingsList() {
      this.$api.offline
        .getModelOfflineSettingsList(this.searchForm)
        .then((res) => {
          this.total = res.count;
          this.tableData = res.data;
        });
    },
    // 删除
    handleDel(row) {
      this.$confirm("是否确定删除？", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      }).then(() => {
        this.$api.offline.delModelOfflineSettings(row.id).then((res) => {
          if (res.code == 200) {
            this.$toaster.ok(res.msg);
            this.searchKey();
          }
        });
      });
    },
    // 添加
    handleAdd() {
      this.title = "添加离线模板配置";
      this.ruleForm.id = "";
      this.dialogVisible = true;
    },
    // 编辑
    handleUpdate(row) {
      this.title = "编辑离线模板配置";
      this.dialogVisible = true;
      this.ruleForm.id = row.id;
      this.ruleForm.offlineDetails = [];

      // 获取离线模板
      this.getModelOfflineSettings(row.id);
    },
    // 获取离线模板
    getModelOfflineSettings(id) {
      this.$api.offline.getModelOfflineSettings({ id: id }).then((res) => {
        if (res.code == 200) {
          res.data.offlineDetails.forEach((val) => {
            val.type = val.type != undefined ? val.type.toString() : "";
            val.pushModeArr =
              val.pushMode != undefined &&
                val.pushMode != "" &&
                val.pushMode != null
                ? val.pushMode.split(",")
                : [];
          });

          this.ruleForm.id = res.data.id;
          this.ruleForm.name = res.data.name;
          this.ruleForm.offlineDetails = res.data.offlineDetails;
        }
      });
    },
    // 保存
    handleSave() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          let bo = true;
          this.ruleForm.offlineDetails.forEach((val) => {
            if (val.type === "" || val.pushModeArr.length == 0) {
              bo = false;
              return;
            }

            if (val.type == 0 && val.intervalTime === "") {
              bo = false;
              return;
            }

            if (
              val.type == 1 &&
              (val.intervalDay === "" || val.remindTime === "")
            ) {
              bo = false;
              return;
            }

            val.pushMode = val.pushModeArr.toString();
          });

          if (!bo) {
            this.$toaster.error("请完善模板明细");
            return;
          }

          this.ruleForm.token = store.state.user.token;
          this.$api.offline
            .saveModelOfflineSettings(this.ruleForm)
            .then((res) => {
              if (res.code == 200) {
                this.$toaster.ok(res.msg);
                this.handleClose();
                this.searchKey();
              }
            });
        } else {
          this.$toaster.error("保存失败，请先完善配置信息");
        }
      });
    },
    // 关闭添加编辑弹窗
    handleClose() {
      this.ruleForm = {
        // 添加、编辑弹窗表单
        id: undefined,
        name: "",
        offlineDetails: [
          {
            id: undefined,
            type: "",
            intervalTime: "",
            intervalDay: "",
            remindTime: "",
            pushMode: "",
            pushModeArr: [],
          },
        ],
      };
      this.$refs["ruleForm"].resetFields();
      this.dialogVisible = false;
    },
    // 添加明细
    handleAddDetail() {
      this.ruleForm.offlineDetails.push({
        id: undefined,
        type: "",
        intervalTime: "",
        intervalDay: "",
        remindTime: "",
        pushMode: "",
        pushModeArr: [],
      });
    },
    // 删除明细
    handleDelDetail(index) {
      this.ruleForm.offlineDetails.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.demo-ruleForm {
  width: 95%;
  margin: -10px 0 0 0;
  padding-top: 10px;

  .el-row {
    margin-bottom: 20px;
  }

  .el-select {
    width: 100% !important;
  }

  .el-input-number {
    width: 100% !important;
  }

  .el-cascader {
    width: 100% !important;
    margin-bottom: 0px !important;
  }
}
</style>